let isDeepLinkValue = false;

export default function isDeepLink(): boolean {
    return isDeepLinkValue;
}

export function setIsDeepLink(value: boolean): void {
    isDeepLinkValue = value;
}
